import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { customerModalStore } from '../../store';
import { ICustomersModalItem } from '../../types';
import { getTranslate } from 'src/utils/helpers';

interface IProps {
  customer?: ICustomersModalItem;
}

const CustomersModalCustomer: FC<IProps> = observer(({ customer }: IProps): JSX.Element => {
  const { isEmptyThisAll, selectedCustomers } = customerModalStore;

  const isActive = useMemo((): boolean => {
    return isEmptyThisAll ? true : selectedCustomers.some((_customer) => customer?.id === _customer.id);
  }, [customer, isEmptyThisAll, selectedCustomers]);

  const isUnavailable = useMemo((): boolean => {
    return Boolean(customer?.is_delete);
  }, [customer]);

  const onClick = () => {
    if (isUnavailable || !customer) return;
    customerModalStore.selectCustomer(customer);
  };

  const customerClassName = useMemo((): string => {
    let className: string = 'custom-modal__item mb-2 mr-2';

    if (isActive) className += ' custom-modal__item_active';
    if (isUnavailable) className += ' custom-modal__item_no-available';

    return className;
  }, [isActive, isUnavailable]);

  return (
    <>
      {customer ? (
        <li className={customerClassName}>
          <div className="custom-modal__item__name-wrapper px-3" onClick={onClick}>
            <p className="custom-modal__item__name">{getTranslate(customer.name) || customer.mobile}</p>
          </div>
        </li>
      ) : (
        <div className="custom-modal__item custom-modal__item__skeleton mb-2 mr-2">
          <Skeleton width="100%" height="100%" />
        </div>
      )}
    </>
  );
});

export default CustomersModalCustomer;
